import {combineSlices, configureStore} from '@reduxjs/toolkit';

import authSlice from './features/auth/slice';
import homeSlice from './pages/home/reducer';
import globalSlice from './reducer';

export const rootReducer = combineSlices(globalSlice, authSlice, homeSlice);

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({reducer: rootReducer});

export type AppDispatch = typeof store.dispatch;
